import { Pipe, PipeTransform } from '@angular/core';
import { CalendarSource, CalendarSourceType } from '../data/calendar-source.interface';

@Pipe({
  standalone: false,
  name: 'friendlySourceType',
})
export class FriendlySourceTypePipe implements PipeTransform {
  transform(source: CalendarSource): string {
    switch (source.type) {
      case CalendarSourceType.Price:
        return 'price';

      case CalendarSourceType.Availability:
        return 'availability';

      case CalendarSourceType.MinStay:
        return 'minimum length of stay';

      case CalendarSourceType.CICOAvailability:
        return 'check-in and checkout availability';

      default:
        return source?.type ?? '';
    }
  }
}
